import * as Sidebar from './Sidebar.css';

export default {
	Sidebar
};
